export const RELEWISE_MINIMUM_STOCK_COUNT = 2;
